import React from "react";
import { Card, Grid, CardContent, Box, CardHeader, Avatar, IconButton, Typography } from "@mui/material";

import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';

import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import {statusColours} from "../../../constants/Colour";
import RenderDate from "../../Common/Date/RenderDate";
dayjs.extend(relativeTime)

function StatementListItem () {

    const assessment = this.props.data;
    const expired =  dayjs().isAfter(assessment.dateEnd, 'day')

    const renderSubscriptionNote = () => {
        if(expired) {
            return "Expired " + dayjs().to(dayjs(assessment.dateEnd));
        } else {
            return "Expires " + dayjs().to(dayjs(assessment.dateEnd));
        }
    }
    let avatarStyle = {backgroundColor: statusColours.main, color: '#FFF'};

    if(expired) {
        avatarStyle = {backgroundColor: statusColours.light, color: '#FFF'};
    }

    return (
        <React.Fragment>
            <Card>
                <CardHeader
                    avatar={
                        <Avatar
                            aria-label="subscription"
                            style={avatarStyle}
                            sx={{ width: 52, height: 52, marginRight: '4px'}}
                        >
                            <AssessmentOutlinedIcon />
                        </Avatar>
                    }
                    action={
                            <IconButton aria-label="settings">
                                <MoreVertOutlinedIcon/>
                            </IconButton>
                    }
                    title={<Typography variant="h3">{assessment.label}</Typography>}
                    subheader={<Typography variant="subtitle2"><RenderDate date={assessment.dateStart} /></Typography>}
                />
                <CardContent>
                    <Box className="card-content">
                        <Grid container spacing={4}>
                            <Grid item xs={12} sm={6} md={6} >
                                <Grid container spacing={4}>
                                    <Grid item xs={12}>
                                            <Typography variant="body2">
                                                <RenderDate date={assessment.dateStart} />
                                                &nbsp;-&nbsp;
                                                <RenderDate date={assessment.dateEnd} />
                                            </Typography>
                                            <Typography variant="body2">{renderSubscriptionNote()}</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} >
                                <Grid container spacing={4}>
                                    <Grid item xs={12}>
                                        <Typography variant="body2">{assessment.uuid}</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                </CardContent>
            </Card>
        </React.Fragment>
    )
}

export default StatementListItem;
